import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, styled, Theme, Typography, useMediaQuery } from '@mui/material'
import { LanguageUtils } from '@pbt/pbt-ui-components'

import KioskSelectableButton from '../../buttons/KioskSelectableButton'

const StyledRoot = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(4, 5, 2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 2, 0),
  },
}))

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Rubik',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '100%',
  letterSpacing: '0px',
  textAlign: 'center',
  marginBottom: theme.spacing(4),
}))

const StyledButtonContainer = styled(Grid)({
  maxWidth: '800px',
  margin: '0 auto',
})

interface ReferralSourceSelectorProps {
  readonly onSourceSelected: (sourceId: string) => void
  readonly referralSources: Array<{
    [key: string]: any
    id: string
    name: string
  }>
  readonly selectedSourceId: string | null
  readonly showTitle?: boolean
}

const ReferralSourceSelector: React.FC<ReferralSourceSelectorProps> = ({
  selectedSourceId,
  onSourceSelected,
  referralSources,
  showTitle = true,
}) => {
  const { t } = useTranslation('Common')
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))
  const chipSpacing = isMobile ? 2 : 3

  return (
    <StyledRoot container item spacing={0}>
      <Grid
        container
        item
        alignItems="center"
        direction="column"
        justifyContent="center"
      >
        {showTitle && (
          <StyledText variant="h5">
            {t('Common:HOW_DID_YOU_HEAR_ABOUT_US')}
          </StyledText>
        )}
        <StyledButtonContainer
          container
          item
          justifyContent="center"
          spacing={chipSpacing}
        >
          {referralSources.map((source) => (
            <Grid item key={source.id} sm={4} xs={12}>
              <KioskSelectableButton
                isSelected={selectedSourceId === source.id}
                onClick={() => onSourceSelected(source.id)}
              >
                {LanguageUtils.getTranslatedFieldName(source)}
              </KioskSelectableButton>
            </Grid>
          ))}
        </StyledButtonContainer>
      </Grid>
    </StyledRoot>
  )
}

export default ReferralSourceSelector
